// extracted by mini-css-extract-plugin
export var divider = "_ti-0";
export var systemMessage = "_ti-1";